/**
 * Audit log enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
export const auditActionLabels = {
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    restore: 'Restore',
};
export const auditActionValues = Object.keys(auditActionLabels);
export const auditActorTypeLabels = {
    user: 'User',
    system: 'System',
    job: 'Job',
};
export const auditActorTypeValues = Object.keys(auditActorTypeLabels);
//# sourceMappingURL=audit.js.map